export default "__VITE_ASSET__DketfqJY__"